import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { API } from 'aws-amplify';
import axios from 'axios';
import { Link } from 'react-router-dom';
import {
  ModalWithdrawVirtualAccount,
  DetailWithdraw,
  ButtonClose,
  ButtonConfirm,
  Success,
  ActionSection,
  Headers
} from './withdrawVirtualAccount.styles';
import banks from 'src/constants/banks';
import { getInvestorBankAccount } from 'src/graphql/customized_queries';
import createNumber from 'src/functions/createNumber';
import { environment, url } from 'src/environments';
import { InputField } from 'src/utilities/UILibrary/Forms/InputField/InputField';

export default function WithdrawVirtualAccount({
  showModalWithdrawVirtualAccount,
  setModal,
  amount,
  personalInformation
}) {
  const [showInput, setShowInput] = useState(false);
  const [messageId, setMessageId] = useState();
  const [otp, setOtp] = useState('');
  const [successText, setSuccessText] = useState(false);

  const [available] = useState(true);
  const closeModal = () => setModal(false);
  const user = useSelector((state) => state.user.currentUser);
  const [accountInfo, setAccountInfo] = useState(null);
  const [selectedBank, setSelectedBank] = useState(null);
  const [selectedBankCode, setSelectedBankCode] = useState('');
  const [conceptoPago, setConceptoPago] = useState('');
  const [monto, setMonto] = useState('');
  const [CLABE, setCLABE] = useState('');

  const personalData = personalInformation?.data?.getInvestor?.personalInformation;
  const stpData = personalInformation?.data?.getInvestor?.STP;
  const companyData = personalInformation?.data?.getInvestor?.companyInformation;

  function formatCurrency(availableAmount) {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN'
    }).format(availableAmount);
  }

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const { data } = await API.graphql({
          query: getInvestorBankAccount,
          variables: { id: user.id }
        });
        setAccountInfo(data);
      } catch (error) {
        console.error(error);
      }
    };
    if (user.id) {
      fetchUserData();
    }
  }, [user.id]);

  const handleBankChange = (event) => {
    const selectedBank = accountInfo?.getInvestor?.banks?.items?.find(
      (item) => item.identifier === event.target.value
    );
    setSelectedBank(selectedBank);
    if (selectedBank) {
      setSelectedBankCode(selectedBank.bankName);
      setCLABE(selectedBank.CLABE);
    }
  };

  const handleSendEmail = () => {
    const input = {
      id: user.id,
      typeOfUser: 'investor',
      typeMessage: 'withdrawMoney',
      email: user.email,
      timestamp: Date.now()
    };
    axios
      .post(`${url}/${environment}/admin/send-otp-to-email`, input)
      .then((response) => {
        const parsedBody = JSON.parse(response.data.body);
        setMessageId(parsedBody.messageId);
        setShowInput(true);
      })
      .catch((error) => {
        console.error(error);
      });
    setShowInput(true);
  };

  const handleOtpSubmit = async () => {
    const input = {
      id: user.id,
      messageId: messageId,
      code: otp,
      timestamp: Date.now(),
      typeOfUser: 'investor'
    };
    const config = {
      headers: {
        apiKey: `${process.env.REACT_APP_APIKEY_STP}`,
        'Content-Type': 'application/json'
      }
    };
    try {
      const validationCode = await axios.post(
        `${url}/${environment}/admin/email/validate-otp`,
        input
      );
      const parsedBody = JSON.parse(validationCode.data.body);
      if (!parsedBody.isVerified) {
        alert('Validación de código fallida');
        return;
      }
      let stpBody;
      if (user.typeOfPerson === 'FISICA') {
        stpBody = {
          clienteId: user.id,
          tipoCliente: 'investor',
          conceptoPago: conceptoPago,
          cuentaBeneficiario: CLABE,
          institucionContraparte: String(selectedBankCode),
          monto: monto,
          nombreBeneficiario: personalData.fullName,
          referenciaNumerica: createNumber(),
          nombreOrdenante: personalData.fullName,
          rfcCurpBeneficiario: personalData.RFC,
          rfcCurpOrdenante: personalData.RFC,
          cuentaOrdenante: stpData.CLABE
        };
      } else if (user.typeOfPerson === 'MORAL') {
        stpBody = {
          clienteId: user.id,
          tipoCliente: 'investor',
          conceptoPago: conceptoPago,
          cuentaBeneficiario: CLABE,
          institucionContraparte: String(selectedBankCode),
          monto: monto,
          nombreBeneficiario: companyData.companyName,
          referenciaNumerica: createNumber(),
          nombreOrdenante: companyData.companyName,
          rfcCurpBeneficiario: companyData.RFC,
          rfcCurpOrdenante: companyData.RFC,
          cuentaOrdenante: stpData.CLABE
        };
        try {
          const stp = await axios.put(
            `${process.env.REACT_APP_STPURL_FINSPHERA}/registra-orden`,
            stpBody
          );
        } catch (error) {
          console.error(error);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <ModalWithdrawVirtualAccount showModalWithdrawVirtualAccount={showModalWithdrawVirtualAccount}>
      {!successText ? (
        <div>
          <Headers>
            <h3>Retirar fondos de cuenta virtual Finsphera</h3>
            <figure onClick={closeModal}>
              <img
                src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_modal_close.png`}
                alt="ícono para cerrar la ventana"
              />
            </figure>
          </Headers>
          <DetailWithdraw isAvailable={available}>
            <h3>
              Tu saldo actual: <p>{formatCurrency(amount)}</p>
            </h3>
            <div>
              <p>Concepto de pago</p>
              <input
                type="text"
                name="conceptoPago"
                placeholder="Descripción"
                value={conceptoPago}
                onChange={(e) => setConceptoPago(e.target.value)}
              />
            </div>
            <div>
              <p>Monto a retirar:</p>
              <input
                type="number"
                name="monto"
                placeholder="$0.00"
                value={monto}
                onChange={(e) => {
                  if (e.target.value > amount) {
                    alert('No puedes ingresar un monto mayor a tu saldo disponible');
                  } else {
                    setMonto(e.target.value);
                  }
                }}
              />
            </div>
            <div>
              <p>Selecciona a que CLABE deseas retirar:</p>
              <select
                name="CLABE"
                value={selectedBank?.identifier || ''}
                onChange={handleBankChange}
              >
                <option value="none">Seleccione:</option>
                {accountInfo?.getInvestor?.banks?.items?.map((item, index) => (
                  <option key={index} value={item.identifier}>
                    {`${item.identifier} | ${item.bankName}`}
                  </option>
                ))}
              </select>
            </div>
          </DetailWithdraw>
          {showInput ? (
            <ActionSection>
              <p>Ingresa el código que enviamos a tu correo:</p>
              <input
                type="text"
                value={otp}
                onChange={(e) => {
                  setOtp(e.target.value);
                }}
              />
              <ButtonConfirm onClick={handleOtpSubmit}>Confirmar código</ButtonConfirm>
            </ActionSection>
          ) : (
            <ActionSection>
              <ButtonConfirm onClick={handleSendEmail}>Confirmar retiro</ButtonConfirm>
            </ActionSection>
          )}
        </div>
      ) : (
        <Success>
          <figure>
            <img
              src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_modal_success.png`}
              alt="icono de correo electrónico"
            />
          </figure>
          <h2>¡Tu retiro se ha registrado de forma exitosa!</h2>
          <ButtonClose onClick={closeModal}>Cerrar</ButtonClose>
        </Success>
      )}
    </ModalWithdrawVirtualAccount>
  );
}
